import React from 'react';
import { Dropdown, Icon, Avatar, Menu } from 'antd';
import { QUERY_COLOR, CATEGORY_COLOR } from './entityColors';

const getLabel = (tab) => {
  if (tab.query) {
    return tab.query.name || `Query ${tab.query.id}`;
  } else if (tab.category) {
    return tab.category.sourceId || 'New Category';
  }
  return '';
};


const getColor = (tab) => {
  if (tab.query) {
    return QUERY_COLOR;
  } else if (tab.category) {
    return CATEGORY_COLOR;
  }
  return 'none';
};

const getIcon = (tab) => {
  if (tab.id === 'home') {
    return 'home';
  } else if (tab.id === 'browse') {
    return 'folder';
  } else if (tab.query) {
    return 'code-o';
  } else if (tab.category) {
    return 'inbox';
  }
  return '';
};

class AppTab extends React.Component {
  handleOpen = (e) => {
    const { active, id, onOpen } = this.props;
    if (active) {
      e.preventDefault();
    } else {
      onOpen(id);
    }
  };

  handleClose = (e) => {
    const { id, onClose } = this.props;
    e.preventDefault();
    e.stopPropagation();
    onClose(id);
  };

  render() {
    const {
      isLoading,
      isPinned,
      isActive,
      ...props
    } = this.props;

    return (
      <button
        type="button"
        key={props.id}
        style={{'--tab-color': getColor(props)}}
        className={`
              vb-tab_window-tab
              ${isActive ? 'vb-tab_window-tab--active' : ''}
            `}
        onClick={this.handleOpen}
      >
        <div className="vb-tab_window-tab-header" style={{backgroundColor: getColor(props)}}/>
        <span className="vb-tab_window-tab-icon">
            <Avatar
              size="small"
              icon={isLoading ? 'loading' : getIcon(props)}
              shape="square"
              style={{
                background: getColor(props),
                color: getColor(props) === 'none' ? 'rgba(0, 0, 0, 0.65)' : '#fff',
              }}
            />
          </span>
        {!isPinned && <span className="vb-tab_window-tab-name">{getLabel(props)}</span>}
        {!isPinned && <span onClick={this.handleClose} className="vb-tab_window-tab-close"><Icon type="close"/></span>}
      </button>
    );
  }
}

export default AppTab;
